import {RestService, ApiWrapper} from '@wemogy/reactbase';
import {IDatabaseTemplate} from '../../models/DatabaseTemplate';

export default class DatabaseTemplateService extends RestService<IDatabaseTemplate>{
  public constructor(apiWrapper: ApiWrapper){
    super(apiWrapper, 'databaseTemplate');
  }
}
